export default "__VITE_ASSET__BVeyYLqg__"